import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGaugesComponent } from './simple-icons-gauges.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGaugesComponent ],
    exports:      [ SimpleIconsGaugesComponent ],
    bootstrap:    []
})
export class SimpleIconsGaugesModule {}
